
import CodelessBindingSetup from './CodelessBindingSetup';
import CodelessSubConfirmation from './CodelessSubConfirmation';
import CodelessBindingSuccess from './CodelessBindingSuccess';
import CodelessNoSubConfirmation from './CodelessNoSubConfirmation';
import CodelessFuturePayFail from './CodelessFuturePayFail';
import CodelessPaymentLoading from './CodelessPaymentLoading';
import CodelessBindingRmConf from './CodelessBindingRmConf';
import CslLoginBindingSetup from './CslLoginBindingSetup';
import Footer from './Footer';

const trObj = {
  en: {
    CodelessBindingSetup: CodelessBindingSetup.en,
    CodelessSubConfirmation: CodelessSubConfirmation.en,
    CodelessBindingSuccess: CodelessBindingSuccess.en,
    CodelessNoSubConfirmation: CodelessNoSubConfirmation.en,
    CodelessFuturePayFail: CodelessFuturePayFail.en,
    CodelessPaymentLoading: CodelessPaymentLoading.en,
    CodelessBindingRmConf: CodelessBindingRmConf.en,
    Footer: Footer.en,
    CslLoginBindingSetup: CslLoginBindingSetup.en,
  },
  zh: {
    CodelessBindingSetup: CodelessBindingSetup.zh,
    CodelessSubConfirmation: CodelessSubConfirmation.zh,
    CodelessBindingSuccess: CodelessBindingSuccess.zh,
    CodelessNoSubConfirmation: CodelessNoSubConfirmation.zh,
    CodelessFuturePayFail: CodelessFuturePayFail.zh,
    CodelessPaymentLoading: CodelessPaymentLoading.zh,
    CodelessBindingRmConf: CodelessBindingRmConf.zh,
    Footer: Footer.zh,
    CslLoginBindingSetup: CslLoginBindingSetup.zh,
  }
}

export default trObj;